import React,{useRef, useState, useEffect} from "react";
import { Select, Form } from "react-bootstrap";

class SelectWrp extends React.Component {

	
	
	constructor(props) {
		
		super(props);

		this.feedback = {
			"loading": "spinner-border spinner-border-sm text-info",
			"done": "ri-check-line text-success",
			"error": "ri-error-warning-line text-danger",
			"hide": "d-none",
		};
		
		this.fb = React.createRef();
		
		this.state = {
			class: this.feedback["hide"]
		};
		
	}

	async handleChange(e){
		var self = this;
		this.fb.current.className = this.feedback["loading"];
		var result  = await this.props.onChange(this.props.propertyId, e.target.value, this.props.extraParam);
		if(result)
			this.fb.current.className = this.feedback["done"];
		else
			this.fb.current.className = this.feedback["error"];
		
		setTimeout(
			()=>{
				if(self.fb.current)
					self.fb.current.className = self.feedback["hide"];
			}
			,2000
		);
	};


	render() {
		return (
			<div className={this.props.wrpClass ? this.props.wrpClass : 'selectWrp ms-auto'}>
				<Form.Select onChange={(e)=>{this.handleChange(e);}} defaultValue={this.props.selected}>
				{this.props.options.map((o, k)=>{return (<option key={k} value={o.value}>{o.label}</option>)})}
				</Form.Select>
				<div className="feedback"><i ref={this.fb} className={this.feedback["hide"]}></i></div>
			</div>
		);
	}
}

export default SelectWrp;